// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VideoPlayer from 'vue-video-player';
import { config, setConfig } from 'CONFIG';
import Vuex from 'vuex';
import store from '@/store';
import i18n from 'LANG';
import '@/common/css/base.less';
import '@/common/css/skin.less';
import '@/common/font/style.css';
import VueTouch from 'vue-touch';
import 'babel-polyfill';
import nprogress from 'nprogress';
import VueLazyload from 'vue-lazyload';
import { getfeature } from '@/common/js/utils';
import { getOfficialUrl } from '@/common/js/url';
import user from '@/api/user';
import { requestToApp } from '@/api/app';
import * as filters from '@/filter';
require( 'nprogress/nprogress.css' );

// test component
require( '@/test/console' );

// mock.js
// require( '@/test/mock' );

Vue.prototype.FEATURE = ( featrue ) => {

    return getfeature( featrue );

};

Vue.prototype.getOfficialUrl = getOfficialUrl;

Vue.use( VueLazyload );

// progress
nprogress.configure({ showSpinner: false });

Vue.config.productionTip = false;

// 页面全局点击
Vue.prototype.globalClick = ( callback ) => {

    $( document ).click( callback );

};

// touch
Vue.use( VueTouch, {name: 'v-touch'});

// player
Vue.use( VideoPlayer );

Vue.use( Vuex );

// vue模版中的全局过滤器
Object.keys( filters ).forEach( key => {

    Vue.filter( key, filters[key] );

});

const initapp = () => {

    /* eslint-disable no-new */
    new Vue({

        el: '#app',
        router,
        components: { App },
        template: '<App/>',
        i18n,
        store

    });

};

const init = () => {

    // 兼容低版本系统的App
    // https://github.com/kazupon/vue-i18n/issues/215
    if ( !global.Intl ) {

        require.ensure( [

            'intl',
            'intl/locale-data/jsonp/en.js'

        ], function ( require ) {

            require( 'intl' );
            require( 'intl/locale-data/jsonp/en.js' );
            initapp();

        });

    } else {

        initapp();

    }

};

/**
 * 在app webview内
 *
 * 1、先启动WebViewJavascriptBridge（Android）
 *
 * 2、获取token和client id
 *
 * 3、初始化vue实例
 */
function WebViewJavascriptBridgeInit () {

    window.WebViewJavascriptBridge.init( function ( message, callback ) {

        callback( message );

    });

}
const initInApp = () => {

    if ( config.client === 'Android' ) {

        if ( window.WebViewJavascriptBridge ) {

            WebViewJavascriptBridgeInit();
        
        } else {

            document.addEventListener( 'WebViewJavascriptBridgeReady', function () {

                WebViewJavascriptBridgeInit();

            });
        
        }

    } else {

        window.IOSCaller = {};
        window.responseToJS = function ( name, data ) {

            window.IOSCaller[ name ]( data );

        };

    }

    // 获取App登录的token和client id
    requestToApp( 'getToken', undefined, function ( tokenData ) {

        let { token, clientId } = JSON.parse( tokenData );
        user.setValue( 'accessToken', token );
        setConfig( 'clientId', clientId );
        user.refreshHeader();
        // 获取在浏览器内回到App的url
        requestToApp( 'getAppUrl', undefined, function ( urlData ) {

            let { url } = JSON.parse( urlData );

            setConfig( 'app_url', url );
            init();

        });

    });

};

if ( config.platform === 'app' ) {

    $( 'body' ).addClass( 'app-not-show' );

    /**
     * ready回调可以保证WebViewJavascriptBridge已加载
     */
    $( document ).ready( function () {

        setTimeout( initInApp, 0 );

    });

} else {

    init();

}



// WEBPACK FOOTER //
// ./src/main.js